import template from './benefitRequestCard.html';
import controller from './benefitRequestCard.controller';
import './benefitRequestCard.scss';

let benefitRequestCardComponent = {
  restrict: 'E',
  bindings: {
    isMobileApp: '<',
    request: '<',
    processRequest: '&',
    dayPeriods: '<',
    cardId: '@'
  },
  template,
  controller
};

export default benefitRequestCardComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestList/benefitRequestCard/benefitRequestCard.component.js